export default "__VITE_ASSET__Clojw1G9__"